import { baseUrlAssets as assets } from "lib/actions/endpoints/endpoints";
import { Endpoint } from "lib/types/Endpoint";

export const endpointsSpeckle = {
  workspaces: (speckleConnectedAccountId: number) =>
    `${assets}/accounts/${speckleConnectedAccountId}/speckle/workspaces`,
  projects: (speckleConnectedAccountId: number, workspaceId: string) =>
    `${assets}/accounts/${speckleConnectedAccountId}/speckle/workspaces/${workspaceId}/projects`,
  models: (speckleConnectedAccountId: number, speckleProjectId: string) =>
    `${assets}/accounts/${speckleConnectedAccountId}/speckle/projects/${speckleProjectId}/models`,
  versions: (
    speckleConnectedAccountId: number,
    speckleProjectId: string,
    speckleModelId: string,
  ) =>
    `${assets}/accounts/${speckleConnectedAccountId}/speckle/projects/${speckleProjectId}/models/${speckleModelId}/versions`,
  import: {
    url: `${assets}/speckle/import`,
    method: "POST",
  } as Endpoint,
  createProject: (
    speckleConnectedAccountId: number,
    workspaceId: string,
  ): Endpoint => ({
    url: `${assets}/accounts/${speckleConnectedAccountId}/speckle/workspaces/${workspaceId}/projects`,
    method: "POST",
  }),
  createModel: (
    speckleConnectedAccountId: number,
    speckleProjectId: string,
  ): Endpoint => ({
    url: `${assets}/accounts/${speckleConnectedAccountId}/speckle/projects/${speckleProjectId}/models`,
    method: "POST",
  }),
  pkceGenerateChallenge: `${assets}/speckle/auth/pkce/generate`,
  accounts: `${assets}/speckle/auth/useraccounts`,
  requestAuthEndpoint: (appRegistrationId: number, challenge: string) =>
    `${assets}/speckle/auth/${appRegistrationId}/request?challenge=${challenge}`,

  exchangeCode: (appRegistrationId: number): Endpoint => ({
    url: `${assets}/speckle/auth/${appRegistrationId}/exchange`,
    method: "POST",
  }),
  appRegistrations: (workspaceId: number) =>
    `${assets}/workspace/${workspaceId}/speckle/auth/apps`,
  validateAccount: (speckleConnectedAccountId: string) =>
    `${assets}/speckle/auth/useraccount/${speckleConnectedAccountId}/validate`,
  getAutomation: (
    projectId: number,
    speckleConnectedAccountId: number,
    speckleProjectId: string,
  ) =>
    `${assets}/speckle/automations/project/${projectId}/speckleAccount/${speckleConnectedAccountId}/speckleProject/${speckleProjectId}`,
  toggleAutomation: {
    url: `${assets}/speckle/automations/toggle`,
    method: "POST",
  },
  createAutomation: {
    url: `${assets}/speckle/automations/create`,
    method: "POST",
  },
  isUserProjectOwner: (
    speckleConnectedAccountId: number,
    speckleProjectId: string,
  ) =>
    `${assets}/speckle/useraccount/${speckleConnectedAccountId}/stream/${speckleProjectId}/isOwner`,
};
